function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.123 504.123",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469"
    },
    cx: 252.062,
    cy: 252.062,
    r: 252.062
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M212.283,93.342c-63.015,0-113.822,41.354-113.822,92.16c0,14.178,3.938,27.569,11.422,40.172 l-19.298,56.32l57.895-20.086c18.905,10.24,40.96,15.754,63.803,15.754c62.622,0,113.822-41.354,113.822-92.16 S274.905,93.342,212.283,93.342z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 212.283,
    cy: 185.502,
    r: 48.837
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "196.923,156.751 196.923,214.646 241.822,185.502  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M389.12,346.191c6.695-11.028,9.846-22.843,9.846-35.052c0-44.111-44.505-79.951-98.855-79.951 s-98.855,35.84-98.855,79.951s44.505,79.951,98.855,79.951c19.692,0,38.991-4.726,55.138-13.785l50.412,17.329L389.12,346.191z  M252.062,329.649c-9.058,0-16.542-7.483-16.542-16.542c0-9.058,7.483-16.542,16.542-16.542c9.058,0,16.542,7.483,16.542,16.542 C268.603,322.166,261.514,329.649,252.062,329.649z M303.262,329.649c-9.058,0-16.542-7.483-16.542-16.542 c0-9.058,7.483-16.542,16.542-16.542c9.058,0,16.542,7.483,16.542,16.542C319.803,322.166,312.714,329.649,303.262,329.649z  M354.462,329.649c-9.058,0-16.542-7.483-16.542-16.542c0-9.058,7.483-16.542,16.542-16.542s16.542,7.483,16.542,16.542 C371.003,322.166,363.914,329.649,354.462,329.649z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastSupport);
export default __webpack_public_path__ + "static/media/fast-support.432f502b1da0d8167f5a4c9e21b846b6.svg";
export { ForwardRef as ReactComponent };